"use client";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfoundAudioCall from "../components/agent-avatar";
import { HeaderSection } from "../features/AgentPage/Header/HeaderSection";
import { ProfileCard } from "../features/AgentPage/ProfileCard/ProfileCard";
import { CallToActionSection } from "../features/AgentPage/CallToAction/CallToActionSection";
import { AppLoadingScreen } from "../components/app-loading-screen";
import { useAgentPage } from "../features/AgentPage/hooks/useAgentPage";
import { useWhoAmI } from "../hooks/useWhoAmI";

export default function AgentPageClient() {
  const navigate = useNavigate();
  const { userData: whoamiUserData, loading: whoamiLoading } = useWhoAmI();

  const [startConversation, setStartConversation] = useState(false);
  const { linkedinLoading, linkedinUserData, userData, hasLinkedinData } = useAgentPage(
    whoamiUserData,
    whoamiLoading
  );

  const handleEndCall = async () => {};

  const handleTransitionComplete = () => {
    // Always redirect to waitlist page, which will check the API for conversation ID
    navigate("/agent/waitlist");
  };

  const hasAllData =
    hasLinkedinData &&
    linkedinUserData?.userName &&
    linkedinUserData?.profilePictureUrl !== undefined;

  if (whoamiLoading || linkedinLoading || !hasAllData) {
    return <AppLoadingScreen />;
  }

  const {
    firstName,
    userName,
    profilePictureUrl,
    currentRole,
    currentCompany,
    headline,
    location,
    education,
    summaryPreview,
    experience,
  } = linkedinUserData;

  if (startConversation) {
    return (
      <div className="opacity-0 animate-[fadeIn_0.5s_ease-in-out_forwards]">
        <ProfoundAudioCall
          userData={userData}
          linkedinLoading={linkedinLoading}
          linkedinUserData={linkedinUserData}
          onEndCall={handleEndCall}
          onTransitionComplete={handleTransitionComplete}
        />
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-start px-4 sm:px-6 md:px-8 py-8 sm:py-12"
      style={{ background: "#F6F4E5" }}
    >
      <div className="w-full max-w-4xl">
        <HeaderSection firstName={firstName} />

        <ProfileCard
          userName={userName}
          profilePictureUrl={profilePictureUrl}
          currentRole={currentRole}
          currentCompany={currentCompany}
          headline={headline}
          location={location}
          education={education}
          summaryPreview={summaryPreview}
          experience={experience}
        />

        <CallToActionSection onStartConversation={() => setStartConversation(true)} />
      </div>
    </div>
  );
}
